module.exports = __webpack_public_path__ + "static/media/logo-anage-calculadora.893ae5f0.svg";